import Vue from "vue";
import Router from "vue-router";
import LoginPage from "@/views/LoginPage.vue";
import MainPage from "@/views/MainPage.vue";
import AdminPage from "@/views/AdminPage.vue";
import MyAppPage from "@/views/MyAppPage.vue";
import BulletinsPage from "@/views/BulletinsPage.vue";
import DocumentationPage from "@/views/DocumentationPage.vue";
import CalendarPage from "@/views/CalendarPage.vue";
import DatabasesPage from "@/views/DatabasesPage.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: "",
  routes: [
    {
      path: "/login",
      name: "login",
      component: LoginPage
    },
    {
      path: "/",
      beforeEnter(to, from, next) {
        if (to.query && to.query.bulletinType) {
            // redirect to route below
            next({ name: 'login', query: to.query })
        } else 
            next({name: 'login'})
     }
    },
    {
      path: "/main",
      name: "main",
      component: MainPage,
      redirect: "/myapp",
      children: [
        {
          path: "/admin",
          name: "admin",
          component: AdminPage
        },
        {
          path: "/databases",
          name: "database",
          component: DatabasesPage
        },
        {
          path: "/calendar",
          name: "calendar",
          component: CalendarPage
        },
        {
          path: "/documentation",
          name: "documentation",
          component: DocumentationPage
        },
        {
          path: "/bulletins",
          name: "bulletins",
          component: BulletinsPage
        },
        {
          path: "/myapp",
          name: "myapp",
          component: MyAppPage
        }
      ]
    }
  ]
});
